import requestClient from '../components/Utility/RequestClient';

export const mcpService = {
    // MCP Configurations
    getConfigs: async (
        demo: boolean = false,
        page: number = 1,
        itemsPerPage: number = 10,
        optionalParams?: Record<string, string>,
        query?: string | null,
    ): Promise<{ data: { data: any[]; total: number } }> => {
        return requestClient.get(`/mcp/configs`, {
            params: {
                page,
                itemsPerPage,
                query,
            },
        });
    },

    getConfig: async (identifier: string): Promise<{ data: any }> => {
        return requestClient.get(`/mcp/config/${identifier}`);
    },

    createConfig: async (data: any): Promise<{ data: any }> => {
        return requestClient.post('/mcp/config/create', data);
    },

    updateConfig: async (identifier: string, data: any): Promise<{ data: any }> => {
        return requestClient.post(`/mcp/config/${identifier}/update`, data);
    },

    deleteConfig: async (identifier: string): Promise<any> => {
        return requestClient.delete(`/mcp/config/${identifier}/delete`);
    },

    testConnection: async (identifier: string): Promise<{ data: any }> => {
        return requestClient.post(`/mcp/config/${identifier}/test`);
    },

    syncTools: async (identifier: string): Promise<{ data: any }> => {
        return requestClient.post(`/mcp/config/${identifier}/sync`);
    },

    // MCP Tools
    getTools: async (
        identifier: string,
        page: number = 1,
        itemsPerPage: number = 10,
        query: string | null = null,
    ): Promise<{ data: { data: any[]; total: number } }> => {
        return requestClient.get(`/mcp/config/${identifier}/tools`, {
            params: { page, itemsPerPage, query },
        });
    },

    executeTool: async (identifier: string, args: any): Promise<{ data: any }> => {
        return requestClient.post(`/mcp/tool/${identifier}/execute`, { arguments: args });
    },

    discoverAuthorizationServer: async (configId: string): Promise<{ data: any }> => {
        return requestClient.post(`/mcp/config/${configId}/oauth/discover-authorization-server`);
    },

    registerDynamicallyClient: async (configId: string): Promise<{ data: any }> => {
        return requestClient.post(`/mcp/config/${configId}/oauth/register-dynamically-client`);
    },

    // OAuth management
    startOAuth: async (configId: string): Promise<{ data: any }> => {
        return requestClient.post(`/mcp/config/${configId}/oauth/start`);
    },

    refreshOAuthToken: async (configId: string): Promise<{ data: any }> => {
        return requestClient.post(`/mcp/config/${configId}/oauth/refresh`);
    },

    checkOAuthToken: async (configId: string): Promise<{ data: any }> => {
        return requestClient.get(`/mcp/config/${configId}/oauth/check`);
    },
};
